<div class="app-wrapper">
  <img 
    [src]="bg" 
    *ngFor="let bg of background.reverse()"
    class="bg-img"
    (load)="onBgImgload($event)"
    @bgAnim>
  <div class="btn refresh" (click)="changeBgImg()" *ngIf="!loadingImg" @fadeInAnim>
    <i class="material-icons">refresh</i>
  </div>
    <div class="top-section">
      <app-header></app-header>
    </div>
    <div class="content-section" [@routeAnim] = 'prepareRoute(outlet)'>
        <router-outlet #outlet = 'outlet'></router-outlet>
    </div>
    <nav class="bottom-section">
      <app-nav></app-nav>
    </nav>
    <app-notification></app-notification>
</div>
